import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children"];
import { isValidElement, cloneElement, Children } from 'react';
import { Tabs } from 'foundations-components/transitional/components/Tabs';
import { useLocation, matchPath } from 'quartz-routing/react-router';
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * A [`Tabs`](https://private.hubteamqa.com/foundations-components-storybook/?path=/docs/transitional-tabs--basic)
 * type component with router support.
 */
const RouterTabs = props => {
  const {
      children
    } = props,
    rest = _objectWithoutPropertiesLoose(props, _excluded);
  const location = useLocation();
  let selected = undefined;
  const tabs = Children.map(children, (element, i) => {
    if (! /*#__PURE__*/isValidElement(element)) {
      return null;
    }
    const tabId = element.props.tabId !== undefined ? element.props.tabId : `${i}`;
    if (!selected) {
      const {
        to,
        exact = false,
        strict = false
      } = element.props;
      const path = typeof to === 'object' ? to.pathname : to;
      if (matchPath(location.pathname, {
        path,
        exact,
        strict
      })) {
        // eslint-disable-next-line react-hooks/immutability
        selected = tabId;
      }
    }
    return /*#__PURE__*/cloneElement(element, {
      tabId
    });
  });
  return /*#__PURE__*/_jsx(Tabs, Object.assign({}, rest, {
    selected: selected,
    children: tabs
  }));
};
export default RouterTabs;